var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSkill2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 31.082 31.082",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M616.669,186.48a14.4,14.4,0,1,0,14.4,14.4,14.4,14.4,0,0,0-14.4-14.4m0,29.939a15.541,15.541,0,1,1,15.541-15.541,15.541,15.541,0,0,1-15.541,15.541",
    transform: "translate(-601.128 -185.337)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 4.422,
    height: 0.639,
    transform: "translate(13.462 22.031)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 4.422,
    height: 0.792,
    transform: "translate(13.462 20.815)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M621.173,198.458a.213.213,0,0,0-.253.162l-.039.183h-1.027l.427-1.095a.141.141,0,0,0-.233-.15l-1.657,1.691.28-1.568a.141.141,0,0,0-.111-.165.142.142,0,0,0-.125.039l-1.333,1.286h-.872l-.048-.22a.212.212,0,0,0-.414.088l1.82,8.441h.422a.177.177,0,0,0,0-.043l-1.721-7.984h.869a.15.15,0,0,0,.1-.04l1.06-1.023-.284,1.589a.141.141,0,0,0,.075.15.145.145,0,0,0,.064.017.147.147,0,0,0,.1-.042l1.5-1.527-.252.645a.143.143,0,0,0,.014.131.145.145,0,0,0,.117.062h1.174l-1.73,8.022a.12.12,0,0,0,0,.043h.421l1.82-8.441a.211.211,0,0,0-.161-.252h0",
    transform: "translate(-602.84 -186.762)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 4.422,
    height: 0.792,
    transform: "translate(13.462 23.096)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M622.032,200.964s-1.882,3.119-2.04,4.668a.552.552,0,0,1-.318.447h.113v4.168c0,.656-.73,1.215-1.75,1.423a.724.724,0,0,1-.7.67h-.374a.726.726,0,0,1-.7-.669c-1.02-.209-1.751-.768-1.751-1.424v-1.459h0v-.425h0v-.64h0V207.3h0v-1.219h.127a.55.55,0,0,1-.318-.442c-.133-1.427-2.133-4.669-2.125-4.658a7.969,7.969,0,0,1-1.264-3.74,6.181,6.181,0,1,1,12.351-.512c.007.17.007.342,0,.512a7.94,7.94,0,0,1-1.257,3.729m-5.013-12.627a12.9,12.9,0,1,0,12.9,12.9,12.9,12.9,0,0,0-12.9-12.9h0",
    transform: "translate(-601.478 -185.689)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M619.836,193.341a5.71,5.71,0,0,1,1.286.475,4.369,4.369,0,0,1,1.819,1.819,5.844,5.844,0,0,1,.476,1.286,3.072,3.072,0,0,0-3.581-3.579",
    transform: "translate(-603.317 -186.268)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkill2);
export default __webpack_public_path__ + "static/media/skill2.fa17fb36.svg";
export { ForwardRef as ReactComponent };